import * as React from 'react';
import { Form_BooleanInputProps } from '../../../../../../react-commons/components/form/inputs/Form_BooleanInput';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyBooleanInput = <T extends object>({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<Form_BooleanInputProps<T, false>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'nullable'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <Inputs.Boolean
        nullable={false}
        {...propertyInfo}
        {...props}
    />;
};
